import React, { useState, forwardRef, useImperativeHandle } from 'react';
import * as Utils from '../../commons/utils/Utils';
import { FormattedMessage } from 'react-intl';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    CircularProgress
} from '@material-ui/core';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';

const PresupuestoHistorico = forwardRef(({region},ref) => {
    const [presupuestoHistorico, setPresupuestoHistorico] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPresupuestoHistorico = async () => {
        try {
            setLoading(true);
            const response = await Utils.getData(`/presupuestos/presupuesto-historico/${region}`);
            setPresupuestoHistorico(response);
        } catch (error) {
            console.error('Error fetching presupuesto historico:', error);
        } finally {
            setLoading(false);
        }
    };

    // Expose the fetchPresupuestoHistorico function to the parent component
    useImperativeHandle(ref, () => ({
        fetchPresupuestoHistorico
    }));

    return (
        <div>
            <TableContainer>
                <Table aria-label="clases table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_region" defaultMessage="Region" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_subregion" defaultMessage="Subregion" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_base" defaultMessage="Base" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_periodo" defaultMessage="Periodo" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_usuario" defaultMessage="Usuario" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_fecha_modificacion" defaultMessage="Fecha Modificación" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_monto_general" defaultMessage="Monto General" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_monto_preventivo" defaultMessage="Monto Preventivo" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_monto_correctivo" defaultMessage="Monto Correctivo" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_monto_gestoria" defaultMessage="Monto Gestoria" />
                            </StyledTableCell>
                            <StyledTableCell>
                                <FormattedMessage id="PresupuestoHistorico.rennder.column_monto_vencimiento" defaultMessage="Monto Vencimiento" />
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <StyledTableCell colSpan={11} align="center">
                                    <CircularProgress />
                                </StyledTableCell>
                            </TableRow>
                        ) : (
                            presupuestoHistorico.map((historico) => (
                                <TableRow key={historico.id}>
                                    <StyledTableCell>{historico.region_nombre}</StyledTableCell>
                                    <StyledTableCell>{historico.subregion_nombre}</StyledTableCell>
                                    <StyledTableCell>{historico.base_descripcion}</StyledTableCell>
                                    <StyledTableCell>{historico.periodo_nombre}</StyledTableCell>
                                    <StyledTableCell>{historico.persona_apellido} {historico.persona_nombre}</StyledTableCell>
                                    <StyledTableCell>{historico.fecha_modificacion}</StyledTableCell>
                                    <StyledTableCell>{parseFloat(historico.monto_general)}</StyledTableCell>
                                    <StyledTableCell>{parseFloat(historico.monto_preventivo)}</StyledTableCell>
                                    <StyledTableCell>{parseFloat(historico.monto_correctivo)}</StyledTableCell>
                                    <StyledTableCell>{parseFloat(historico.monto_gestoria)}</StyledTableCell>
                                    <StyledTableCell>{parseFloat(historico.monto_vencimientos)}</StyledTableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
});

export default PresupuestoHistorico;